
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ForgetPasswordPage from './Components/ForgetPassword';
import AuthenticationForm from './Components/AuthenticationForm';
import lupa_login_s from './images/lupa_login_s.gif';
import NewPassword from './Components/NewPassword';
import LanguageProvider, { LanguageContext } from './language/LanguageContext';
import { LicenseProvider } from './language/LicenseContext';
import { use100vh } from 'react-div-100vh';
import { useContext } from 'react';
import { Box } from '@mui/material';
import consts from './Utilities/appConsts.json';
import ActionMessage from './Components/ActionMessage';
import { useEffect } from 'react';
import packageJson from "../package.json";

function AppContent() {
  const height = use100vh();
  const { language } = useContext(LanguageContext);
  
  return (
    <LicenseProvider language={language.id}>
    <Router>
      <Box sx={{ height: height }} className="display-screen"
      >
        <img className='img-logo' src={lupa_login_s} alt="GIF"/>
        <div>

          <Routes>  
          <Route path="/" element={<Navigate to="/loginregister" />} />
          <Route  path="/loginregister" element={<AuthenticationForm />} />
         <Route path="/forgetpassword" element={<ForgetPasswordPage />} />
         <Route path="/newpassword" element={<NewPassword />} />
         <Route path="/sucssespassword" element={<ActionMessage isDisplayImg={true} mainTextLink="" mainText={consts.SUCCSES_PASSWORD} linkText={consts.BACK_TO_APP} />} />
         <Route path="/succsesregister" element={<ActionMessage isDisplayImg={true} mainTextLink="" mainText={"החשבון שלך הופעל בהצלחה"} linkText={consts.BACK_TO_APP} />} />
         <Route path="/processregister" element={<ActionMessage isDisplayImg={false} mainTextLink="שלחנו למייל שלך קישור להפעלת החשבון החדש שלך" mainText={"יופי, מעכשיו יש לך חשבון בלופה"} linkText={consts.BACK_TO_APP} />} />
        </Routes>
       
        </div>
      </Box>
    </Router> 
    </LicenseProvider>
  );
}

function App() {
  useEffect(() => {
    console.log("Version:", packageJson.version);
  }, []);
  
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
